import { useAppDispatch } from 'store/store-hooks';
import { useAppNavigator, Path } from 'components/_hooks/use-router';
import { setConfigPanel } from 'components/app/editor/_mediator/editor.slice';
import styles from './_selector-clips.module.scss';

export const __SrEmpty = () => {
  const { navigateTo } = useAppNavigator();
  const dispatch = useAppDispatch();

  const onClick = () => {
    navigateTo(Path.storyboard);
    dispatch(setConfigPanel(null));
  };

  return (
    <div className={styles.Grid__empty}>
      <h3>Tag some highlights</h3>
      <p>
        These tags will be used to create the clips on the <span onClick={onClick}>Storyboard</span>
      </p>
    </div>
  );
};
